import React from "react";
import style from './PenaltyGoalButtons.scss'
import Submit from "./../HandleSubmit";

const submitEvent = (props, postType) => {
    const { matchData, setMatchData, matchId, formatApiData, sides, setEventsToShow, homePlayers, awayPlayers } = props;
    const eventWithId = matchData.matchPosts[matchData.matchPosts.length - 1];
    const {homeTeamObject, awayTeamObject, homeGoals: initialHomeGoals, awayGoals: initialAwayGoals } = matchData;

    const { id, ...eventWithoutId } = eventWithId;

    const homeGoals = postType === 24 && eventWithoutId.team === homeTeamObject.id ? initialHomeGoals + 1 : initialHomeGoals;
    const awayGoals = postType === 24 && eventWithoutId.team === awayTeamObject.id ? initialAwayGoals + 1 : initialAwayGoals;

    const penaltyEvent = {
        ...eventWithoutId,
        postType,
        homeGoals,
        awayGoals,
        scorerContact: eventWithoutId.shooterContact,
        additionalData: ''
    }

    const update = {
        homeGoals,
        awayGoals,
        matchPosts: [
            ...matchData.matchPosts,
            penaltyEvent,
        ]
    }

    Submit(matchId, matchData, update, setMatchData)
        .then((data) => {
            formatApiData(data, sides, setEventsToShow, ...homePlayers, ...awayPlayers);
        })
        .catch(e => console.error(e.message));
}

const CardDetails = (props) => {
    return (
        <div className={!props.penaltyShootActive ? `${style.penaltyButtons} ${style.disabled}` : style.penaltyButtons}>
            <button className={style['penalty-buttons__goals']} onClick={() => submitEvent(props, 24)}>Goal</button>
            <button className={style['penalty-buttons__miss']} onClick={() => submitEvent(props, 25)}>Miss</button>
        </div>
    );
};

export default CardDetails;
